import React from "react";
import HeroBgAnimation from "../HeroBgAnimation";
import {
	HeroContainer,
	HeroBg,
	HeroLeftContainer,
	Img,
	HeroRightContainer,
	HeroInnerContainer,
	TextLoop,
	Title,
	Span,
	SubTitle,
	ResumeButton,
} from "./HeroStyle";
import HeroImg from "../../Assets/About/HeroImage.png";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";
import Resume from "../../Assets/About/resume.pdf";

const HeroSection = () => {
	return (
		<div id="about">
			<HeroContainer>
				<HeroBg>
					<HeroBgAnimation />
				</HeroBg>
				<HeroInnerContainer>
					<HeroLeftContainer id="Left">
						<Title>
							Hi, I am <br /> {Bio.name}
						</Title>
						<TextLoop>
							I am a
							<Span>
								<Typewriter
									options={{
										strings: Bio.roles,
										autoStart: true,
										loop: true,
									}}
								/>
							</Span>
						</TextLoop>
						<SubTitle>{Bio.description}</SubTitle>
						<ResumeButton
							href={Resume}
							target="_blank"
							download={"Dishang's Resume.pdf"}
						>
							{/* <ResumeButton href={Bio.resume} target="_blank"> */}
							Check Resume
						</ResumeButton>
					</HeroLeftContainer>

					<HeroRightContainer id="Right">
						<Img src={HeroImg} alt="hero-image" />
					</HeroRightContainer>
				</HeroInnerContainer>
			</HeroContainer>
		</div>
	);
};

export default HeroSection;
